import React, {useState, useRef} from 'react';
import {useTranslation} from 'react-i18next';
import {CardElement, ElementsConsumer} from '@stripe/react-stripe-js';
import {Button, TextField} from '@material-ui/core';

// import './PaiementCheckoutForm.scss';

const PaiementCheckoutForm = ({paymentIntent, email, onClose, elements, stripe}) => {
  const [erreur, setErreur] = useState('');
  const [loading, setLoading] = useState(false);
  const [accountholderName, setAccountholderName] = useState('');
  const timeoutId = useRef(0);

  const {t} = useTranslation();

  const handleAccountHolderChange = e => {
    setAccountholderName(e.target.value);
  };

  const getPaymentConfirmResult = async () => {
    if (paymentIntent?.type === 'card') {
      const cardElement = elements.getElement(CardElement);
      return await stripe.confirmCardPayment(paymentIntent.secret, {
        payment_method: {
          card: cardElement,
          billing_details: {
            email,
          },
        },
      });
    }

    if (paymentIntent?.type === 'bancontact') {
      const returnUrl = `${window.location.href}?waitingPaymentConfirmation=${paymentIntent?.type}`;
      return await stripe.confirmBancontactPayment(paymentIntent.secret, {
        payment_method: {
          billing_details: {name: accountholderName},
        },
        return_url: returnUrl,
      });
    }
  };

  const handleSubmit = async event => {
    event.preventDefault();

    if (!stripe || !elements) {
      // Stripe.js has not loaded yet.
      return;
    }

    setLoading(true);
    const result = await getPaymentConfirmResult();
    setLoading(false);

    if (result.paymentIntent?.status === 'succeeded') {
      return (window.location.href = `${window.location.href}?waitingPaymentConfirmation=${paymentIntent?.type}`);
    }

    if (result.error) {
      // Show error (e.g., insufficient funds)
      clearTimeout(timeoutId.current);
      setErreur(result.error.message);
      timeoutId.current = setTimeout(() => setErreur(''), 8000);
    }
  };

  const disabled = !stripe || loading;
  const options = {
    style: {
      base: {
        fontSize: '16px',
        color: '#000',
        '::placeholder': {
          color: 'grey',
        },
      },
      invalid: {
        color: '#9e2146',
      },
    },
  };

  return (
    <>
      <form onSubmit={handleSubmit}>
        {paymentIntent?.type === 'card' && (
          <div className="card">
            <CardElement options={options} />
          </div>
        )}
        {paymentIntent?.type === 'bancontact' && (
          <div className="form-row">
            <TextField
              label={t('nom')}
              name="accountholder-name"
              variant="filled"
              fullWidth
              placeholder={t('nom')}
              required
              value={accountholderName}
              onChange={handleAccountHolderChange}
            />
          </div>
        )}
        <p>
          <Button variant="outlined" color="primary" onClick={onClose}>
            {t('annuler')}
          </Button>{' '}
          &nbsp;
          <Button type="submit" variant="contained" color="primary" disabled={disabled}>
            {paymentIntent?.type === 'bancontact' && t('continuer-vers-bancontact')}
            {paymentIntent?.type === 'card' && t('payer')}
          </Button>
        </p>
        {erreur && <p className="erreur">{erreur}</p>}
      </form>

      {paymentIntent?.type === 'card' && <div className="payment-logos-card" />}
      {paymentIntent?.type === 'bancontact' && <div className="payment-logos-bancontact" />}
    </>
  );
};

export default function InjectedCheckoutForm(props) {
  return (
    <ElementsConsumer>
      {({stripe, elements}) => <PaiementCheckoutForm stripe={stripe} elements={elements} {...props} />}
    </ElementsConsumer>
  );
}
